import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { unsuspendCards } from '../api/rsimActionsApi.ts';

export const useRSimUnsuspendMutation = (
  options?: Omit<UseMutationOptions<void, Error, { euiccIds: string[] }, unknown>, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    mutationFn: (props) => {
      return unsuspendCards(props);
    },
  });
};
